import { Item, ValidationErrors } from "../../../services/types";
import strings from "../../../strings";
import { ListFull } from "../lists/types";
import { PermissionFull } from "../permissions/types";
import { UserFull } from "../users/types";
import * as Fields from "./Fields";

export interface ListUserPermissionFull extends Item {
  id: number;
  list: ListFull;
  user: UserFull;
  permission: PermissionFull;
}

export interface ListUserPermissionForm {
  list: ListFull | null;
  user: UserFull | null;
  permission: PermissionFull | null;
}

export interface ListUserPermissionPost {
  listId: number;
  userId: string;
  permission: string;
}

export const mapToPOST = (item: ListUserPermissionForm): ListUserPermissionPost => {
  return {
    listId: item.list?.id || 0,
    userId: item.user?.id || "",
    permission: item.permission?.name || "",
  };
};

export const validate = (
  state: ListUserPermissionForm,
  setErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>,
): boolean => {
  const errors: ValidationErrors = {};
  if (!state.list) {
    errors[Fields.list.fieldName] = strings.required;
  }
  if (!state.user) {
    errors[Fields.user.fieldName] = strings.required;
  }
  if (!state.permission) {
    errors[Fields.permission.fieldName] = strings.required;
  }
  setErrors(errors);
  return Object.keys(errors).length === 0;
};
